import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CreateDesignatedUnitModalService } from '../../services/create-designated-unit-modal.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TypeService } from '../../../../../../../../services/type/type-service';

@Component({
  selector: 'app-create-designated-unit-contribution-details-step',
  templateUrl: './create-designated-unit-contribution-details-step.component.html',
  styleUrls: ['./create-designated-unit-contribution-details-step.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateDesignatedUnitContributionDetailsStepComponent {
  private flowService = inject(CreateDesignatedUnitModalService);
  private ngbActiveModal = inject(NgbActiveModal);
  private typeService = inject(TypeService);

  public formGroup = this.flowService.designatedUnitForm;
  public formSubmitted: boolean = false;
  public isLoading$ = this.flowService.isLoading$;

  public basisForContributionRatesDropdownItems$ =
    this.typeService.designatedUnitContributionRateBasisTypes$.baseTypeToDropdowns();
  public contributionRateCalculationDropdowns$ =
    this.typeService.designatedUnitContributionRateCalculationTypes$.baseTypeToDropdowns();
  public lessThanFullTimeParticipationDropdowns$ =
    this.typeService.designatedUnitLessThanFullTimeParticipationTypes$.baseTypeToDropdowns();

  public cancel(): void {
    this.ngbActiveModal.close();
  }

  public goBack(): void {
    this.flowService.goBack();
  }

  public continue(): void {
    this.formSubmitted = true;
    if (this.formGroup.controls.contributionDetails.valid) {
      this.flowService.submitDesignatedUnit();
    }
  }
}
